import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { images } from "./images";
import { V7VanessaMorningAfter } from "./V7";
import { endReplay } from "../../src/shell/endReplay";
import { galleryScenesList } from "../../src/components/menu/Scenes/gallery/galleryData";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { doWaitImageByTime } from "../helpers/helpers";
// TODO: underpass can happen - write some dialogs
// TODO: - Sex with Vanessa = "Did they catch you?"

export const V7VanessaMorning = async (): Promise<any> => {


    return jump(V7VanessaMorning2, "V7VanessaMorning2");
};



export const V7VanessaMorning2 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room2, { duration: 1 });
    await mc.setQuestion(new Question({ text: `I can make it a bit more interesting...`, options: { think: true }, key: `v7VanessaMorningOutNaked` })
        .option({ title: `Meet her naked`, key: true })
        .option({ title: `Stay in your clothes`, key: false }));
    if (Question.globalAnswers.v7VanessaMorningOutNaked) {
        mc.think(`You gotta handle crazy with crazy.`);
    } else {
        mc.think(`Nah... It's not a good idea.`);
    }
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_21, { duration: 1 });
    mc.think(`There she is... Sitting with her pink skirt.`);
    mc.think(`If I didn't known her I might mistake her for a sweet innocent girl.`);


    if (Question.globalAnswers.v7VanessaMorningOutNaked) {

        mc.think(`But then again, here I am, about to meet her completely naked.`);
        ImageClass.setImage({ ...images.v7.V7VanessaMCNudeHome_0, partialsToDisplay: [images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p] });
        return jump(V7VanessaMorning2_Naked, "V7VanessaMorning2_Naked");

    }

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    vanessa.talk(`Finally!`);
    mc.talk(`What are you doing here?`);
    vanessa.talk(`Haven't you gotten used to me coming over uninvited by now?`);
    mc.talk(`Yeah... I kinda have.`);


    return jump(V7VanessaMorning2_3, "V7VanessaMorning2_3");

};

export const V7VanessaMorning2_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    await vanessa.setQuestion(new Question({ text: `I don't know, what do you say?`, options: { think: false }, key: `v7VanessaGiveCustomerWhatHeWants` })
        .option({ title: `Give him what he wants`, key: true })
        .option({ title: `Let's find dirt on him`, key: false }));


    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        mc.talk(`Give him what he wants.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
        vanessa.talk(`Seriously?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Why not? Just do it and be done with it.`);
        vanessa.talk(`But... Do I really want to touch his dick...?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Maybe you are wrong and he doesn't want something sexual.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
        vanessa.talk(`${mc.name}?`);
        mc.talk(`Ah?`);
        vanessa.talk(`Are you stupid?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Maybe you are right.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`Of course I'm right!`);
        vanessa.talk(`Well... A dick is a dick...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`A dick is a dick...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`Yeah, I'll just do it.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
        vanessa.talk(`The only reason I didn't want to do it was because he is so eager to get it.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`But I don't care anymore. I just want my job back.`);



    } else {
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Let's find dirt on him.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`He looks so shady, I bet it's gonna take us five minutes!`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Exactly.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`I'm supposed to meet him tonight at the coffee shop after closing hours.`);
        vanessa.talk(`And he knows we are in this together so he wouldn't be surprised if you'll be there too.`);
        vanessa.talk(`So just talk to him and try to find out something.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Why would he want to tell me anything about himself?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
        vanessa.talk(`I don't know OK?! Let's just hope he'll spill something out.`);
        mc.talk(`Fine by me.`);
    }


    return jump(V7VanessaMorning3, "V7VanessaMorning3");
};
export const V7VanessaMorning2_3 = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`V6VanessaCustomerMeeting`)) {

        ImageClass.setImage({ ...images.v7.V7VanessaMCNudeHome_0, partialsToDisplay: [images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2] });
        vanessa.talk(`So, funny thing happened this morning.`);
        vanessa.talk(`A delivery man woke me up and handed me a package.`);
    } else {
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0, { duration: 1 });
        vanessa.talk(`So... Why didn't you tell me you have a goddess ${emily.properties.relation}??`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`I don't know... It didn't really came up. We don't talk about that stuff.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`You should've! Damn... That body.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Are you bi?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
        vanessa.talk(`For her, I will be.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`Ok, relax.`);
        vanessa.talk(`Grr...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);

        vanessa.talk(`Ok, let me get explain why I'm here.`);
        vanessa.talk(`This morning a delivery man woke me up and handed me a package. `);

    }
    // TODO: IF VANESSA DIDN'T MEET EMILY BEFORE
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
    vanessa.talk(`Do you know what was inside?`);
    mc.talk(`I have no idea...`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`A short-- A very short dress.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`Sounds like you got the right package, what's wrong with that?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
    vanessa.talk(`No idiot! I didn't order it! If my parents would've opened it I would be dead!`);
    mc.talk(`Alright, so who sent it?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    vanessa.talk(`Guess.`);
    mc.talk(`Mmm...`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`Our friendly neighborhood grandpa.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`No shit.\nHow do you know? Did he leave a note?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`He did.`);
    vanessa.talk(`The note said: "I hope it's your size, and if it's not even better."`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`Yeah, it sounds like him.`);
    mc.talk(`So, what are you going to do?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_10, { duration: 1 });
    vanessa.talk(`That's why I came here...`);
    vanessa.talk(`To get your help.`);
    mc.talk(`How can I help?`);
    vanessa.talk(`Are you hungry?`);
    mc.talk(`Odd question... Not so much, but I can eat. Why?`);

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_11, { duration: 1 });
    vanessa.talk(`Go ahead.`);
    mc.talk(`Are you serious?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_11.partials.V7VanessaMCNudeHome_11_p, { duration: 1 });

    await vanessa.setQuestion(new Question({ text: `Come on, I need to think.`, options: { think: false }, key: `v7AteVanessaPussy` })
        .option({ title: `Eat her pussy`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v7AteVanessaPussy) {
        await mc.set((properties) => {
            properties.vanessaRelationship += 5;
        });
        return jump(V7VanessaMorning2_EatPussy, "V7VanessaMorning2_EatPussy");




    }
    mc.talk(`No thank you, I'm good.`);
    ImageClass.setImage({ ...images.v7.V7VanessaMCNudeHome_0, partialsToDisplay: [images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1], options: { duration: 1 } });
    vanessa.talk(`What the fuck ${mc.name}? Don't you want me to get my job back?`);
    mc.talk(`I do, but why do I have to eat your pussy for you to get it?`);
    vanessa.talk(`It helps me think.`);
    vanessa.talk(`God, you are so selfish.`);
    if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt || Question.globalAnswers.v6HadSexVanessaLivingRoom) {
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt && Question.globalAnswers.v6HadSexVanessaLivingRoom) {
            vanessa.talk(`I'm starting to regret all those blowjobs you got.`);

        } else {
            vanessa.talk(`I'm starting to regret that blowjob you got from me.`);

        }

    } else {

    }
    mc.talk(`Relax, it's still early, I just woke up.`);
    vanessa.talk(`You owe me one.`);
    mc.talk(`...`);


    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`Let's just think in the old boring way.`);
    vanessa.talk(`Obviously that creepy grandpa wants something from me.`);
    vanessa.talk(`And after seeing the dress, I bet it's something sexual.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`You had to see the dress to figure that out?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
    vanessa.talk(`Shut up!`);
    vanessa.talk(`Anyway!`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`I don't know what do you...`);
    vanessa.talk(`I can just give him what he wants...To be honest, I don't really care.`);
    vanessa.talk(`I just want to get it over with.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`If that's your only option, where's the dilemma?`);
    vanessa.talk(`Duh! That's why I came here. To see if you can come up with a better solution.`);
    mc.talk(`We can try to find some dirt of him. You know, something that will give us leverage over him.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
    vanessa.talk(`How did you think about that without someone sucking your dick???`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
    mc.talk(`I guess I'm just talented.`);

    mc.talk(`Ok, so that settles it.`);

    return jump(V7VanessaMorning2_2, "V7VanessaMorning2_2");
};

export const V7VanessaMorning2_Naked = async (): Promise<any> => {
    mc.talk(`Good morning Sunshine.`);
    await mc.set((properties) => {
        properties.vanessaRelationship++;
    });
    if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {
        vanessa.talk(`Well, well, well, someone grew an appetite after yesterday.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        mc.talk(`What did you expect?`);
        mc.talk(`You left me hanging... I felt like I was about to explode.`);
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            vanessa.talk(`Hmmm... That's the second time I did that... So rude of me.`);

        } else {

        }

        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_2);
        vanessa.talk(`Oh, you poor thing! You are right... You didn't cum.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_3, { duration: 1 });
        vanessa.talk(`You have no one to take care of you?`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_1, { duration: 1 });
        if (mc.properties.annStatus === "gf") {
            vanessa.talk(`I knew I couldn't count on Ann to keep you satisfied.`);

        } else {
            vanessa.talk(`You can't count on your owner to rub you before going to sleep...`);

        }
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_4, { duration: 1 });
        vanessa.talk(`Don't worry. Mama is here.`);
        ImageClass.setImage(images.v7.Anim_VanessaMCFootJob.poster);
        vanessa.talk(`How does that feel?`);
        ImageClass.setAnimation(images.v7.Anim_VanessaMCFootJob);
        mc.talk(`It feels nice...`);
        vanessa.talk(`I bet it does.`);
        mc.talk(`Ah...`);


    } else {
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
        vanessa.talk(`Really?`);
        mc.talk(`What?`);
        if (Question.globalAnswers.v6HadSexVanessaLivingRoom === false) {
            ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);

            vanessa.talk(`After yesterday, now you show up naked?`);
            mc.talk(`Yes. Now I'm horny.`);
            ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
            vanessa.talk(`Tough luck for you, because I'm not.`);
            mc.talk(`...`);
            ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
            vanessa.talk(`I'm joking! I'm always horny!`);
            mc.talk(`Yeah, I knew that was a lie.`);
        } else {
            if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor === false) {
                mc.talk(`You owe me after yesterday!`);
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
                vanessa.talk(`Me? It was your loss! You could've gotten a blowjob...`);
                mc.talk(`When?`);
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
                vanessa.talk(`You should have just stayed put...`);
                mc.talk(`Are you crazy? No way I was going to do that.`);
                vanessa.talk(`Tough luck for you!`);
            } else if (Question.globalAnswers.v6JoeyEnemyAcceptedBJFromVanessa) {
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_1);
                vanessa.talk(`Really? Yesterday's blowjob wasn't enough for you?`);
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
                mc.talk(`If it was, I wouldn't be standing here naked.`);
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2);
                vanessa.talk(`My father is right, you are a smart-ass.`);
                mc.talk(`No... "Joey" is the smart-ass.`);
                // TODO: smiling render
                ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0);
                vanessa.talk(`Haha. Good one.`);
            } else {
                vanessa.talk(`Really? You could've gotten a blowjob yesterday... But you refused.`);
                mc.talk(`And now I won't.`);

            }
        }
        vanessa.talk(`Do I really want to get naked? And start humping...?`);
        vanessa.talk(`I don't know if I should...`);
        vanessa.talk(`What will Joe say about that?`);
        if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {

            mc.talk(`He already had his fun yesterday.`);
        } else {

            mc.talk(`Now you care about his feelings?`);
            if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor === false) {
                vanessa.talk(`Of course! He didn't get any action yesterday.`);
                mc.talk(`...`);
            }
        }

        vanessa.talk(`You know... Walking around in heels all day can make your feet hurt...`);
        vanessa.talk(`So I went to see a chiropractor... He gave me some exercises that should help with the pain...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_2);
        vanessa.talk(`He told me that I should stretch my legs...`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_3);
        vanessa.talk(`And that I need to to keep moving them to get the blood going...`);
        mc.talk(`Ah-ah.`);
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_4);
        vanessa.talk(`I should do it for about a minute straight...`);
        ImageClass.setImage(images.v7.Anim_VanessaMCFootJob.poster, { duration: 1 });
        vanessa.talk(`Like this...`);
        ImageClass.setAnimation(images.v7.Anim_VanessaMCFootJob);
        mc.talk(`I understand.`);
        vanessa.talk(`I don't know... I already feel better, maybe I should stop.`);
        mc.talk(`Don't you dare. Doctor's orders.`);
        vanessa.talk(`You are right. I care a lot about my health.`);

    }

    mc.think(`I've never had a foot fetish but I can't deny it feels... Good... Different.`);

    mc.talk(`I...`);
    mc.talk(`Ahh!!`, { wait: false });
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_8, { wait: .7, shake: true });
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_9, { wait: 1, shake: true });
    vanessa.talk(`There it is. Though I don't think that was even a minute... We need to work on your control. Haha.`);
    vanessa.talk(`Are you relaxed now?`);
    mc.talk(`I am.`);
    await endReplay(replayScenesList.v7VanessaFoot);
    return jump(V7VanessaMorning2_3, "V7VanessaMorning2_3");
};
export const V7VanessaMorning2_EatPussy = async (): Promise<any> => {
    mc.talk(`Can't say no to that.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_14);
    vanessa.talk(`I don't wanna see any crumbs, you hear?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_15);
    vanessa.talk(`Finally! Now I can think!`);

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16, { duration: 1 });
    vanessa.talk(`So let's recap.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16.partials.V7VanessaMCNudeHome_16_p);
    vanessa.talk(`We have a jerk old man that is trying to blackmail me to get my job back.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16);
    vanessa.talk(`He never really stated what he wants besides torturing me.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16.partials.V7VanessaMCNudeHome_16_p);
    vanessa.talk(`I can just say fuck it to my job and it will all be over...`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16);
    vanessa.talk(`No no, that's not good.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16.partials.V7VanessaMCNudeHome_16_p);
    vanessa.talk(`My job is too important.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16);
    vanessa.talk(`We can kill him...`);
    mc.talk(`Mmmm...`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16.partials.V7VanessaMCNudeHome_16_p);
    vanessa.talk(`Relax, I'm just kidding.`);

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16);
    vanessa.talk(`So I can either give him what he wants... I've been with worse, I don't care.`);
    vanessa.talk(`But what if he won't keep his side of the deal?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_16.partials.V7VanessaMCNudeHome_16_p);


    vanessa.talk(`Or maybe fuck the grandpa... I can try and contact the coffee shop owner...`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_17);

    vanessa.talk(`I only saw him once and he didn't seem to like me...`);


    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_17.partials.V7VanessaMCNudeHome_17_p);
    mc.talk(`You know, you can just try to find some dirt on the old guy.`);
    mc.talk(`He got a mysterious call when you met with him at the bar, I'd start there.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_18);
    vanessa.talk(`What do you think you are doing?`);
    mc.talk(`Helping?`);
    vanessa.talk(`You know how to help.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_17);
    vanessa.talk(`Damn, now I lost my train of thought.`);
    vanessa.talk(`Let's recap again.`);

    mc.talk(`Mmm!`);
    vanessa.talk(`Relax, I'm just kidding.`);
    vanessa.talk(`So I need to find out who was the one calling him.`);
    vanessa.talk(`Maybe it was his wife? Or his great-great-great-grandson...`);
    vanessa.talk(`I know! We can find dirt on him!`);
    vanessa.talk(`Yes!`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_19);
    vanessa.talk(`YES!!!`);
    vanessa.talk(`WE CAN TRY AND FIND DIRT ON HIM!!!`);

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_20, { duration: 1.5 });
    mc.talk(`Are you serious?\nThat's basically what I said. And I could've said it before you made me...`);
    vanessa.talk(`Eat breakfast?`);
    vanessa.talk(`But that wouldn't be fun would it?`);
    mc.talk(`For you...`);
    vanessa.talk(`Come on, don't say you didn't enjoy it.\nYou moved your tongue so fast I thought you are going to fly out the window.`);
    mc.talk(`...`);
    await endReplay(replayScenesList.v7VanessaMCHungry);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa || Question.globalAnswers.v6HadSexVanessaLivingRoom || Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {

        vanessa.talk(`Besides, you need to stop being selfish.`);
    } else {

    }

    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0, { duration: 1 });
    mc.talk(`So, you made up your mind?`);
    return jump(V7VanessaMorning2_2, "V7VanessaMorning2_2");
};
export const V7VanessaMorning3 = async (): Promise<any> => {
    if (Question.globalAnswers.v7VanessaMorningOutNaked) {
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2, { duration: 1 });
        vanessa.talk(`Alright. Go get dressed.`);

    } else {
        ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2, { duration: 1 });
        vanessa.talk(`Alright, it's time to go.`);

    }
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0, { duration: 1 });
    mc.talk(`Go where?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2, { duration: 1 });
    vanessa.talk(`To my house, I wanna show you the dress he sent me.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0, { duration: 1 });
    mc.talk(`Why didn't you bring it over?`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2, { duration: 1 });
    vanessa.talk(`So you'd have something to ask.`);
    ImageClass.setImage(images.v7.V7VanessaMCNudeHome_0.partials.V7VanessaMCNudeHome_0_p_2, { duration: 1 });




    return jump(V7VanessaMorningVanessaRoom, "V7VanessaMorningVanessaRoom");
};
export const V7VanessaMorningVanessaRoom = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
    ImageClass.setImage(images.v7.V7VanessaOutfit_6, { duration: 1, wait: 1 });
    vanessa.talk(`Lock the door behind you in case my parents show up again.`);
    doWaitImageByTime(images.v7.V7VanessaOutfit_7);
    vanessa.talk(`Take a look.`);
    vanessa.talk(`Do you see how short it is?`);
    mc.talk(`Well... From here it looks longer than the dress you are currently wearing.`);
    vanessa.talk(`It's just because of the angle I'm holding it!`);
    mc.talk(`If you say so.`);
    vanessa.talk(`Fine.`);
    mc.talk(`I believe you.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_9, { duration: 1 });
    vanessa.talk(`Yeah, yeah, right.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_10);
    vanessa.talk(`Shorter than your dress he says.`, { method: "Mumbling to herself" });
    mc.talk(`I think you are just doing it on purpose at this point.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_11);
    vanessa.talk(`You think?`);
    mc.talk(`I'm not complaining...`);
    vanessa.talk(`Good.`);
    ImageClass.setImage({ ...images.v7.V7VanessaOutfit_12, partialsToDisplay: [images.v7.V7VanessaOutfit_12.partials.V7VanessaOutfit_12_p_1] }, { duration: 1 });
    vanessa.talk(`NOW do you see?`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    mc.talk(`Wow that's some huge cleavage though.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12.partials.V7VanessaOutfit_12_p);
    vanessa.talk(`I know! He has great taste!`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    mc.talk(`Wait... So do you like it?`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    vanessa.talk(`The dress? Of course! The fact he wants me to wear it? Less.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_13);
    vanessa.talk(`Anyway, take a look at it from behind.`);
    await vanessa.setQuestion(new Question({ text: `Anyway, take a look at it from behind.`, options: { think: false }, key: 'v7VanessaMorningRoomToldBendOver' })
        .option({ title: `Bend over`, key: true })
        .option({ title: `Yeah, I agree`, key: false }));


    if (Question.globalAnswers.v7VanessaMorningRoomToldBendOver) {
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        mc.talk(`Bend over, so I could see how bad it really is.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_14);
        vanessa.talk(`Well?`);
        mc.talk(`It's not that bad.`);
        vanessa.talk(`I can literally feel the wind up my asshole.`);
        mc.talk(`Yeah... I lied.`);
        vanessa.talk(`No shit.`);

    } else {

        mc.talk(`Yeah, I agree, I can actually see your butt cheeks.`);
    }

    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    mc.talk(`You know, you can put some panties for a change.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12.partials.V7VanessaOutfit_12_p);
    vanessa.talk(`Funny!`);
    vanessa.talk(`I only wear panties when Ann is around. It helps her feel more comfortable.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    mc.talk(`Why do you always get naked around her?`);
    vanessa.talk(`Why not?`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_12);
    vanessa.talk(`In any case, the grandpa wrote specifically not to put on anything else but the dress.`);
    mc.talk(`What else did he write?`);
    vanessa.talk(`To put on the dress and look pretty. You know, put on some makeup and shit...`);
    vanessa.talk(`You know what? Give me two minutes and I'll show you.`);
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
    ImageClass.setImage(images.v7.V7VanessaOutfit_0, { duration: 1, wait: 1 });
    mc.talk(`Wow, you are really putting on your best look for him.`);
    vanessa.talk(`It's not for him, it's for my job.`);
    ImageClass.setImage(images.v7.V7VanessaOutfit_3, { duration: 1 });
    await vanessa.setQuestion(new Question({ text: `Here is the full package.`, options: { think: false }, key: `v7VanessaMorningRoomToldLookBeautiful` })
        .option({ title: `You look beautiful`, key: true })
        .option({ title: `You look like an escort girl`, key: false }));


    if (Question.globalAnswers.v7VanessaMorningRoomToldLookBeautiful) {
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        mc.talk(`You look beautiful.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3.partials.V7VanessaOutfit_3_p_2, {});
        vanessa.talk(`What a nice thing to say!`);


    } else {
        mc.talk(`You look like an escort girl.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3.partials.V7VanessaOutfit_3_p, {});
        vanessa.talk(`You have been staring at this escort girl since you met her.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3, {});
        mc.talk(`It's not necessarily a bad thing.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3.partials.V7VanessaOutfit_3_p, {});
        if (mc.properties.annStatus === "gf") {
            vanessa.talk(`Tell that to Ann.`);

        } else {
            vanessa.talk(`RRRRight.`);

        }

    }

    ImageClass.setImage(images.v7.V7VanessaOutfit_3.partials.V7VanessaOutfit_3_p, {});
    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        vanessa.talk(`I'll talk to you once I'm done with him.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3, {});
        mc.talk(`Sure.`);

    } else {
        vanessa.talk(`Anyway. Don't forget, coffee shop, tonight.`);
        ImageClass.setImage(images.v7.V7VanessaOutfit_3, {});
        mc.talk(`You can count on me.`);
        vanessa.talk(`...`);
        mc.talk(`What?! I'll be there.`);
    }
    ImageClass.setImage(images.v7.V7VanessaOutfit_3.partials.V7VanessaOutfit_3_p, {});
    vanessa.talk(`Alright. You can leave now.`);

    return jump(V7VanessaMorningAfter, "V7VanessaMorningAfter");
};

export const V7VanessaMorning_JoeRivalConv = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    mc.talk(`So? Are we gonna talk about the elephant in the room?`);
    vanessa.talk(`Are you calling me fat?!`);
    mc.talk(`No... About what happened yesterday.`);
    if (Question.globalAnswers.v6JoeyEnemyAcceptedBJFromVanessa) {
        vanessa.talk(`Congrats! I believe you and Joe are friends again?`);
        mc.talk(`That's it?`);
        vanessa.talk(`Eye for an eye.`);
        vanessa.talk(`You did your thing, he did his thing and that's it.`);
        mc.talk(`He hasn't talked to me yet...`);
        vanessa.talk(`He will. Maybe he is still asleep.`);
        mc.talk(`What about Ann? I was about to call her but you surprised me.`);
        vanessa.talk(`Well! Funny that you asked! But she is ok with that.`);
        mc.talk(`Liar... No way.`);
        vanessa.talk(`I'm not! You can just ask her.`);
        mc.talk(`I will, but how? What did you say?`);
        vanessa.talk(`I don't want to ruin the surprise.`);
        mc.talk(`So that's it? Everything is back to normal?`);
        vanessa.talk(`Seems like it.`);
        // TODO: check if she said that.
        vanessa.talk(`I told you I'll fix everything!`);
        mc.talk(`Yeah...`);
    } else if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor === false) {
        vanessa.talk(`But nothing happened, you stopped it.`);
        mc.talk(`Right. But your plan was fucked up.`);
        vanessa.talk(`Wasn't that eye for an eye?`);
        vanessa.talk(`Besides, it would have worked! Don't you want to make peace with Joe?`);
        mc.talk(`Not like that.`);
        vanessa.talk(`I don't see any other way.`);
        mc.talk(`So be it...`);

    } else {

    }



    //return jump(TODO_JUMP, "TODO_JUMP");
};